///<reference path="../../../plugins/interop/interop.controller.ts" />

module Meevo.Plugins.AdpWiselyIntegration {
    "use strict";

    export class WiselyLogSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            private contextParams: Meevo.ContextParamsService,
            identityService: Components.Common.IIdentityService = null,
            sectionSecurityKey?: string,
        ) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey);
            this.isInteropContext = true;

        }

        selected() {
            super.selected();
            this.contextParams.addInteropParams({ id: 'interop:adp-wisely', isInterop: true, targetRoute: 'adp-wisely/integration/log' });
        }

    }
}